import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFetch, setShowModal } from "../../store/slices/puestosSlice.ts";
import { RootState } from "../../store";
import { notification } from "../../utils/Notifications.tsx";
import { reactivateVacancie } from "../../services/vacancy.service.ts";

const ReactivateRecordPuestos = ({ closeFn }: { closeFn: () => void }) => {
  const { currentRecord, fetch } = useSelector(
    (state: RootState) => state.puestos
  );
  const dispatch = useDispatch();

  const removeRecord = async () => {
    try {
      const response = await reactivateVacancie(currentRecord.id);
      console.log(response);
      dispatch(setFetch(!fetch));
      closeFn();
      notification("Reactivar", "Puesto activado", "success");
    } catch (error) {
      console.log(error);
      notification("Error", error.message, "danger");
    }
  };

  return (
    <React.Fragment>
      <p className="fs-15px">
        ¿Estás seguro de que deseas reactivar a {currentRecord.name}?
      </p>
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-azul" onClick={() => removeRecord()}>
          Reactivar
        </button>
      </div>
    </React.Fragment>
  );
};

export default ReactivateRecordPuestos;
